type TScore = 1 | 2 | 3 | 4 | 5;
type TTextMessage = "feedback" | "feedback-promise";

function addEventListenerOnFeedbackForms() {
  const forms: NodeListOf<HTMLFormElement> = document.querySelectorAll(
    "[data-feedback-form-id]",
  );

  if (forms.length === 0) return;

  for (const form of forms) {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      submitForm(form).then();
    });
  }
}

addEventListenerOnFeedbackForms();

function addEventListenerOnRatingItems() {
  const ratingItems: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-feedback-rating-item]",
  );

  if (ratingItems.length === 0) return;

  for (const item of ratingItems) {
    item.addEventListener("click", async (event: Event) => {
      const { currentTarget } = event as Event & { currentTarget: HTMLElement };

      if (!currentTarget) throw new Error("No currentTarget found");

      const score = Number(
        currentTarget.getAttribute("data-rating-score"),
      ) as TScore;
      const formId = currentTarget.getAttribute("data-id") as string;

      if (!score || !formId) throw new Error("No score or formId found");

      const formSelector = `[data-feedback-form-id='${formId}']`;

      feedbackAfterClickHandler(formSelector, score);
    });
  }
}

addEventListenerOnRatingItems();

function feedbackAfterClickHandler(formSelector: string, score: TScore) {
  if (!score) throw new Error("Score is not a number");
  if (!formSelector) throw new Error("No form selector found");

  const form = document.querySelector(formSelector) as HTMLFormElement | null;

  if (!form) throw new Error("No form found");

  const isFormSubmitted =
    form.getAttribute("data-form-is-submitted") === "true";
  const scoreIsSelected =
    form.getAttribute("data-score-is-selected") === "true";

  if (scoreIsSelected && !isFormSubmitted) {
    unselectForm(form);
    hideText(form);
    return;
  } else if (isFormSubmitted) {
    return;
  }

  updateCurrentSelectedScore(form, score);
  form.setAttribute("data-open-feedback", "open");
  changeText(form, "feedback");
}

function unselectForm(form: HTMLFormElement) {
  form.setAttribute("data-score-is-selected", "false");

  const ratingItems = form.querySelectorAll(
    "[data-feedback-rating-item]",
  ) as NodeListOf<HTMLElement>;
  if (ratingItems.length === 0) throw new Error("No rating items found");

  for (const item of ratingItems) {
    if (item.classList.contains("hidden")) item.classList.remove("hidden");
  }

  form.setAttribute("data-current-selected-score", "");
  form.setAttribute("data-open-feedback", "close");
}

function updateCurrentSelectedScore(form: HTMLFormElement, score: TScore) {
  if (!form) throw new Error("No form found");
  if (!score) throw new Error("No Score found");
  form.setAttribute("data-current-selected-score", score.toString());
  form.setAttribute("data-score-is-selected", "true");
  updateRatingItemsVisibility(form, score);
}

function updateRatingItemsVisibility(form: HTMLFormElement, score: TScore) {
  const ratingItems: NodeListOf<HTMLElement> = form.querySelectorAll(
    "[data-feedback-rating-item]",
  );
  if (ratingItems.length === 0) throw new Error("No rating items found");

  for (const item of ratingItems) {
    const itemScore = Number(item.getAttribute("data-rating-score")) as TScore;

    if (itemScore === score) {
      if (item.classList.contains("hidden")) {
        item.classList.remove("hidden");
      }
    } else {
      item.classList.add("hidden");
    }
  }
}

function changeText(form: HTMLFormElement, selector: TTextMessage) {
  const textMesasges: NodeListOf<HTMLElement> = form.querySelectorAll(
    "[data-text-message]",
  );

  if (textMesasges.length === 0) throw new Error("No text messages found");

  for (const text of textMesasges) {
    if (text.getAttribute("data-text-message") === selector) {
      text.setAttribute("data-show", "true");
    } else {
      text.setAttribute("data-show", "false");
    }
  }
}

function hideText(form: HTMLFormElement) {
  const textMesasges: NodeListOf<HTMLElement> = form.querySelectorAll(
    "[data-text-message]",
  );

  if (textMesasges.length === 0) throw new Error("No text messages found");

  for (const text of textMesasges) {
    text.setAttribute("data-show", "false");
  }
}

async function submitForm(form: HTMLFormElement) {
  if (!form) {
    console.error("submitForm: No form found");
    return;
  }

  const { action } = form;
  const score: TScore = Number(
    form.getAttribute("data-current-selected-score"),
  ) as TScore;

  changeText(form, "feedback-promise");

  form.setAttribute("data-open-feedback", "close");
  form.setAttribute("data-form-is-submitted", "true");

  const formData = new FormData(form);
  formData.append("score", score.toString());

  //@ts-expect-error This combination is iterable and valid
  const serializedParams = new URLSearchParams(formData).toString();

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: serializedParams,
  };
  try {
    const { status, ok } = await fetch(action, config);

    if (!ok) {
      console.error("Form submission failed", status);
    }
  } catch (error) {
    console.error(error);
  }
}
